import { Injectable, Injector } from '@angular/core';

import { Command, CommandHandler } from '@skylab-shared/core';
import { Constructor, Tuple } from '@skylab-shared/types';

export const CommandBusHandlers: Tuple<Function, Constructor<CommandHandler<Command<any, any>, any, any>>>[] = [];

@Injectable({ providedIn: 'root' })
export class CommandBus {

    public constructor(private injector: Injector) { }

    public commandAsync<TCommand extends Command<any, any>>(command: TCommand, params?: any): Promise<TCommand extends Command<any, infer TR> ? TR : unknown> {
        const [_, handler] = CommandBusHandlers.find(([type]) => command instanceof type)!;
        if (!handler)
            throw new Error(`Query handler for "${command.constructor.name}" does not exist.`);
        const commandHandler = this.injector.get(handler);
        return commandHandler.handleAsync(command, params);
    }
}
